import styled from 'styled-components';
import { SCHEDULE } from '../../utils/constants';
import { getDaysUntilDday } from '../../utils/functions';

const StatusComponent = () => {
  const statusOfDday = getDaysUntilDday(SCHEDULE.datetime);

  switch (statusOfDday.status) {
    case 'upcoming':
      return (
        <StyledP>
          영준과 유진의 결혼식까지
          <br />
          <strong>{statusOfDday.daysLeft}일</strong> 남았어요.
        </StyledP>
      );
    case 'today':
      return <StyledP>오늘은 영준과 유진의 결혼식이에요! 🎊</StyledP>;
    case 'past':
      return (
        <StyledP>
          영준과 유진이 결혼한지
          <br />
          <strong>{String(statusOfDday.daysLeft).slice(1)}일</strong> 되었어요.
        </StyledP>
      );
    default:
      break;
  }
};

export default StatusComponent;

const StyledP = styled.p`
  font-size: 1.8rem;
  line-height: 2.4rem;
  text-align: center;

  & > strong {
    font-family: 'Eulyoo1945-Bold';
  }
`;
